import React, { useCallback } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ActiveDropzoneStyle, DropzoneStyle, DropzoneText, ImagePreview } from './DropZoneComponent.styles';
import { DropZoneComponentProps } from './DropZoneComponent.types';
import { useDropzone } from 'react-dropzone';

const DropZoneComponent: React.FC<DropZoneComponentProps> = ({ setImage, image, testId }) => {
  const onDrop = useCallback((acceptedFiles: File[]) => {
    setImage(
      Object.assign(acceptedFiles[0], {
        preview: URL.createObjectURL(acceptedFiles[0]),
      })
    );
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/jpeg': [] },
    maxSize: 1024 * 1024 * 5,
    maxFiles: 1,
  });
  const renderImage = () => {
    return (
      <div style={{ border: '2px dotted lightgray', padding: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <ImagePreview src={image?.preview} alt={image?.name} />
      </div>
    );
  };

  return (
    <div>
      {image ? (
        renderImage()
      ) : (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <ActiveDropzoneStyle>
              <CloudUploadIcon sx={{ fontSize: 150, color: 'lightgray' }} />
              <DropzoneText>Drop the file here ...</DropzoneText>
            </ActiveDropzoneStyle>
          ) : (
            <DropzoneStyle data-testid={testId}>
              <CloudUploadIcon sx={{ fontSize: 150, color: 'lightgray' }} />
              <DropzoneText>Drag and drop here or browse</DropzoneText>
            </DropzoneStyle>
          )}
        </div>
      )}
    </div>
  );
};

export default DropZoneComponent;
